var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 40,
    viewBox: "0 0 48 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1817 39.803C33.2424 39.803 43.1211 24.8333 43.1211 11.8636C43.1211 11.4394 43.1212 11.0151 43.0909 10.5909C45.0151 9.2121 46.6817 7.46968 47.9848 5.49998C46.2272 6.27271 44.3333 6.80301 42.3484 7.04544C44.3787 5.83331 45.9242 3.90907 46.6666 1.62119C44.7727 2.74241 42.6666 3.56059 40.4242 3.99998C38.6211 2.09089 36.0908 0.893921 33.2575 0.893921C27.8333 0.893921 23.4393 5.28786 23.4393 10.7121C23.4393 11.4848 23.5302 12.2273 23.6969 12.9545C15.5302 12.5454 8.30297 8.63635 3.45449 2.69695C2.62116 4.1515 2.12115 5.83332 2.12115 7.63635C2.12115 11.0454 3.84844 14.0454 6.49996 15.8182C4.8939 15.7727 3.37874 15.3333 2.04541 14.5909C2.04541 14.6363 2.04541 14.6818 2.04541 14.7121C2.04541 19.4697 5.43932 23.4394 9.92417 24.3333C9.10599 24.5606 8.24236 24.6818 7.33327 24.6818C6.69691 24.6818 6.09085 24.6212 5.48479 24.5C6.74236 28.4091 10.3636 31.2424 14.6514 31.3182C11.2878 33.9545 7.06054 35.5151 2.45448 35.5151C1.66661 35.5151 0.878745 35.4697 0.106018 35.3788C4.48481 38.1666 9.63629 39.803 15.1817 39.803Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.76af4ed76cc48c5ea17351073f1c5077.svg";
export { ForwardRef as ReactComponent };